module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-a04fc39de55d91c042bf6876b2678e52.svg";